import { API, API_POST } from "../../Config";

export const handleEditSubadmin = (payload) => {
  
  const f = new FormData();
  f.append("id", payload.id);
  f.append("email", payload.email);
  f.append("privileges", payload.privileges);

  return API_POST(API.EditSubAdmin, f);
};
